'use client';

import { Check, Plus } from 'lucide-react';
import type React from 'react';

interface ICollectionWatchToggleProps {
  watched: boolean;
  pending?: boolean;
  markWatchedLabel: string;
  markUnwatchedLabel: string;
  onToggle: () => void;
}

export function CollectionWatchToggle({
  watched,
  pending = false,
  markWatchedLabel,
  markUnwatchedLabel,
  onToggle,
}: ICollectionWatchToggleProps): React.JSX.Element {
  return (
    <button
      type="button"
      aria-pressed={watched}
      aria-label={watched ? markUnwatchedLabel : markWatchedLabel}
      disabled={pending}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onToggle();
      }}
      className={`flex size-7 items-center justify-center rounded-full border shadow-sm backdrop-blur-sm transition outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:opacity-50 ${
        watched
          ? 'border-primary bg-primary text-primary-foreground'
          : 'border-white/60 bg-black/50 text-white hover:bg-black/70'
      }`}
    >
      {watched ? <Check className="size-4" aria-hidden /> : <Plus className="size-4" aria-hidden />}
    </button>
  );
}
